import { ChangeDetectionStrategy, Component } from "@angular/core";
import { CpBaseCardComponent } from "@e-tenant-hub/client-platform/shared/ui/responsive/cards/base-card";

@Component({
	selector: "cp-translucid-card",
	imports: [CpBaseCardComponent],
	templateUrl: "./translucid-card.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CpTranslucidCardComponent {}
